import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { SponserContract } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { AppErrors, NotFoundError } from '@fitness-force/errors';

@Injectable({
  providedIn: 'root'
})
export class SponserContractsService {
  constructor(private http: HttpClient) {}

  getTenantsSponsorContracts(tenantId: number): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/sponsorContracts`;
    return this.http.get<any>(url).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getCompanySponsorContracts(): Observable<any> {
    const url = `${environment.BASE_URL}/companies/sponsorContracts`;
    return this.http.get<any>(url).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }
} 